import styled from 'styled-components';

export const DropdownItemDeleteTestStepStyled = styled.span`
  color: var(--ds-text-danger, var(--ds-fb-text-danger));
`;
